if (!window.customElements.get("swatch-dropdown")) {
  class SwatchDropdown extends HTMLElement {
    constructor() {
      super();

      this.spanFor = this.dataset.spanFor;
      this.dropdown = this.parentElement.querySelector(".select-custom__inner");

      if (this.spanFor) {
        this.addEventListener("click", this.activeFilterSort.bind(this), false);
      }

      this.setDropdownHeight();
    }

    setDropdownHeight() {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this.dropdown) {
            this.parentElement.style.setProperty("--dropdown-height", `${entry.target.getBoundingClientRect().height}px`);
          }
        }
      });

      resizeObserver.observe(this.dropdown);
    }

    activeFilterSort() {
      const spanBlock = this.querySelector(`#${this.spanFor}`);

      if (!spanBlock) {
        return;
      }

      if (spanBlock.classList.contains("active")) {
        spanBlock.classList.remove("active");
      } else {
        spanBlock.classList.add("active");
      }
    }
  }

  customElements.define("swatch-dropdown", SwatchDropdown);
}


if (!window.customElements.get("product-tiers")) {
  class ProductTiers extends HTMLElement {
    constructor() {
      super();

      this.formId = this.dataset.form;
      this.form = document.forms[this.formId];
      this.tiers = this.querySelectorAll(".product-tier");
      this.radios = this.querySelectorAll(".product-tier input[type='radio']");

      this.radios.forEach((radio) => {
        radio.addEventListener("change", () => {
          const variantId = radio.dataset.variantId;
          const variantIdInput = this.form.querySelector("input[name='id']");
          console.log("ateini cia?", variantId)
          
          variantIdInput.value = variantId;
          variantIdInput.dispatchEvent(new Event("change"));
        });
      });

      this.form.addEventListener("variant:change", (evt) => {
        const variant = evt.detail.variant;
        const option1 = variant.option1;
        let isFirst = false;
          console.log("ateini cia2?", variant)



        this.tiers.forEach((tier) => {
          const settings = theme.helpers.safelyParseJson(tier.dataset.tierSettings) || {};
          const radio = tier.querySelector("input[type='radio']");
          let parent = tier.closest(".label-wrapper");

          radio.removeAttribute("checked");
          
          if (settings.optionName === option1) {
            console.log(isFirst);

            if (!isFirst) {
              radio.setAttribute("checked", "true");
            }
            
            if (parent){
              parent.classList.remove("!hidden");
            }else {
              tier.classList.remove("!hidden");
            }
            isFirst = true;
          } else {


             if (parent){
              parent.classList.add("!hidden");

            }else {
              tier.classList.add("!hidden");
            }
          }

        });
      });
    }
  }

  customElements.define("product-tiers", ProductTiers);
}


class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".product-tabs__tab");
    this.productBlocks = this.querySelectorAll(".product-tabs__blocks");

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (evt) => {
        evt.preventDefault();

        const blockId = tab.dataset.blockId;

        this.showContent(blockId);

        this.tabs.forEach((innerTab) => {
          innerTab.classList.remove("underline");
          innerTab.removeAttribute("disabled");
        });

        tab.classList.add("underline");
        tab.setAttribute("disabled", "disabled");
      });
    });
  }

  showContent(blockId) {
    this.productBlocks.forEach((productBlock) => {
      productBlock.classList.add("product-tabs__blocks--refreshing");

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("product-tabs__blocks--hidden");
        } else {
          productBlock.classList.add("product-tabs__blocks--hidden");
        }

        productBlock.classList.add("animated-blocks--hide-instantly");
        productBlock.classList.remove("visible");
        productBlock.classList.remove("product-tabs__blocks--refreshing");
      }, 300);

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("animated-blocks--hide-instantly");
          productBlock.classList.add("visible");
        }
      }, 500);
    });
  }
}


if (!window.customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll(".product-tabs__tab");
      this.productBlocks = this.querySelectorAll(".product-tabs__blocks");

      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", (evt) => {
          evt.preventDefault();

          const blockId = tab.dataset.blockId;

          this.showContent(blockId);

          this.tabs.forEach((innerTab) => {
            innerTab.classList.remove("underline");
            innerTab.removeAttribute("disabled");
          });

          tab.classList.add("underline");
          tab.setAttribute("disabled", "disabled");
        });
      });
    }

    showContent(blockId) {
      this.productBlocks.forEach((productBlock) => {
        productBlock.classList.add("product-tabs__blocks--refreshing");

        setTimeout(() => {
          if (productBlock.dataset.blockId === blockId) {
            productBlock.classList.remove("product-tabs__blocks--hidden");
          } else {
            productBlock.classList.add("product-tabs__blocks--hidden");
          }

          productBlock.classList.add("animated-blocks--hide-instantly");
          productBlock.classList.remove("visible");
          productBlock.classList.remove("product-tabs__blocks--refreshing");
        }, 300);

        setTimeout(() => {
          if (productBlock.dataset.blockId === blockId) {
            productBlock.classList.remove("animated-blocks--hide-instantly");
            productBlock.classList.add("visible");
          }
        }, 500);
      });
    }
  }

  customElements.define("product-tabs", ProductTabs);
}


if (!window.customElements.get("geo-shipping-notice")) {
  class GeoShippingNotice extends HTMLElement {
    constructor() {
      super();

      this.settings = theme.helpers.safelyParseJson(this.getAttribute("settings"));
      this.message = this.querySelector(".geo-shipping-notice__message");
      this.cacheKey = "geoShippingCountry";

      this.init();
    }

    init() {
      if (!this.message || !this.settings) {
        return;
      }

      const excluded = this.settings.excludedCountries.split(",").map((c) => c.trim().toUpperCase());
      // const cached = this.getCached();

      // if (cached) {
      //   this.renderMessage(excluded, cached.country, cached.code);

      //   return;
      // }

      if (this.settings.country) {
        const country = this.settings.country;
        const code = this.settings.countryCode;

        // this.setCached(country, code);
        this.renderMessage(excluded, country, code);

        this.classList.remove("invisible");
      } else {
        this.message.innerText = "Unable to detect location.";

        this.classList.add("!hidden");
      }

      // fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.language}`)
      //   .then((res) => res.json())
      //   .then((data) => {
          
      //   })
      //   .catch(() => {
          
      //   });
    }

    renderMessage(excluded, country, code) {
      const flag = code ? String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt())) : "🌐";
      const isExcluded = excluded.includes(code);
      const template = isExcluded ? this.settings.messageUnsupported : this.settings.messageSupported;

      this.message.innerHTML = template.replace("[country]", country).replace("[flag]", flag);

      this.classList.remove("invisible");
    };

    getCached() {
      const oneDay = 24 * 60 * 60 * 1000;

      try {
        const cached = JSON.parse(localStorage.getItem(this.cacheKey));

        if (cached && Date.now() - cached.timestamp < oneDay) {
          return cached;
        }
      } catch {}

      localStorage.removeItem(this.cacheKey);

      return null;
    };

    setCached(country, code) {
      localStorage.setItem(this.cacheKey, JSON.stringify({
        country,
        code,
        timestamp: Date.now()
      }));
    };
  }

  customElements.define("geo-shipping-notice", GeoShippingNotice);
}


if (!window.customElements.get("sticky-atc-bar")) {
  class StickyAtcBar extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.section = document.querySelector(`.product-section[data-section-id="${this.sectionId}"]`);
      this.position = this.dataset.position;
      this.select = this.querySelector(".sticky-atc-bar__select");
      this.image = this.querySelector(".sticky-atc-bar__image img");
      this.atcButton = this.section.querySelector(".product-form__buy-button");
      this.mainForm = this.atcButton.closest("form");
      this.mainVariants = this.section.querySelectorAll("variant-radios-detail fieldset");
      this.variantsData = this.querySelector(".product-variants-json");
      this.variantsJSON = this.variantsData ? JSON.parse(this.variantsData.textContent) : []
      this.form = this.querySelector("form");
      this.quantityInputs = [this.querySelector("input[name='quantity']"), this.section.querySelector("input[name='quantity']")];

      this.buttonRect = null;

      this.init();

      this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
      this.handleVariantChangeListener = this.handleVariantChange.bind(this);
      this.handleSelectChangeListener = this.handleSelectChange.bind(this);
    }

    init() {
      this.moveOutsideSection();
      this.setInitialPosition();
      this.observeAtcButton();
      this.handleScroll();
      this.syncQuantityInputs();
      this.setBarHeight();
    }

    connectedCallback() {
      window.addEventListener("scroll", this.handleScrollListener, { passive: true });
      this.mainForm?.addEventListener("variant:change", this.handleVariantChangeListener);
      this.select.addEventListener("change", this.handleSelectChangeListener);
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScrollListener);
      this.mainForm?.removeEventListener("variant:change", this.handleVariantChangeListener);
      this.select.removeEventListener("change", this.handleSelectChangeListener);
    }

    setBarHeight() {
      document.documentElement.style.setProperty("--sticky-bar-height", `${this.getBoundingClientRect().height}px`);

      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this) {
            document.documentElement.style.setProperty("--sticky-bar-height", `${entry.target.getBoundingClientRect().height}px`);
          }
        }
      });

      resizeObserver.observe(this);
    }

    handleVariantChange(event) {
      const variant = event.detail.variant;

      if (variant) {
        const element = this.querySelector('[name="id"]');

        element.value = variant.id;
        element.dispatchEvent(new Event("change", { bubbles: true }));

        this.select.value = variant.id;

        this.form.dispatchEvent(new CustomEvent("variant:change", {
          detail: {
            variant: variant
          }
        }));
      }
    }

    handleSelectChange() {
      const option = this.select.options[this.select.selectedIndex];
      const imageSrc = option.dataset.image;
      const variantId = +this.select.value;
      const variant = this.variantsJSON.find((variant) => {
        return variant.id === variantId;
      });

      console.log("duok variant", variant)
      const element = this.querySelector('[name="id"]');

      element.value = variantId;
      element.dispatchEvent(new Event("change", { bubbles: true }));

      this.mainVariants.forEach((fieldset, index) => {
        const option = variant[`option${index + 1}`];
        const select = fieldset.querySelector("select");
        const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(option)}"]`);

        if (select) {
          select.value = option;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      if (this.image && imageSrc) {
        this.image.src = imageSrc;
        this.image.removeAttribute("srcset");
      }
    }

    syncQuantityInputs() {
      this.quantityInputs.forEach((input) => {
        input.addEventListener("change", () => {
          const value = +input.value;

          this.quantityInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    }

    moveOutsideSection() {
      const existingStickyBar = document.querySelector("body > .sticky-atc-bar");

      existingStickyBar?.remove();

      document.body.appendChild(this);
    }

    setInitialPosition() {
      this.buttonRect = this.atcButton.getBoundingClientRect();
      this.buttonTopOffset = this.atcButton.getBoundingClientRect().top + window.scrollY;
    }

    handleScroll() {
      const scrollY = window.scrollY;

      if (!this.buttonRect) {
        return;
      }

      const isAbove = scrollY > this.buttonTopOffset + this.atcButton.offsetHeight;

      if (isAbove) {
        this.showSticky();
      } else {
        this.hideSticky();
      }
    }

    observeAtcButton() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.setInitialPosition();

            if (entry.isIntersecting) {
              this.hideSticky();
            }
          });
        },
        {
          root: null,
          threshold: 0,
        }
      );

      observer.observe(this.atcButton);
    }

    showSticky() {
      this.classList.add("visible");
      document.body.classList.add("sticky-atc-bar-visible");
      document.body.classList.add(`sticky-atc-bar-position-${this.position}`);
    }

    hideSticky() {
      this.classList.remove("visible");
      document.body.classList.remove("sticky-atc-bar-visible");
    }
  }

  customElements.define("sticky-atc-bar", StickyAtcBar);
}